import { Typography } from "@suraasa/placebo-ui"
import {
  MedProgramCard,
  PgctlProgramCard,
} from "features/Home/GetStartedWithProgramsBanner"
import { context } from "global/Context/context"
// import { ArrowRight } from "iconoir-react"
import { useContext } from "react"

const GetStartedBannerForCourses = () => {
  const { profile } = useContext(context)
  const firstName = profile.user.firstName
  return (
    <div
      className="mb-10 rounded-[20px] p-4.5"
      style={{
        background:
          "linear-gradient(175.26deg, #FFFFFF 30.85%, rgba(243, 235, 243, 0.5) 68.97%, #E7EEF4 96.17%)",
      }}
    >
      <div className="flex flex-col gap-2 md:flex-row">
        <div className="flex flex-col items-start justify-between">
          <div className="flex flex-col">
            <Typography
              variant={"body"}
              className="text-[20px] text-onSurface-400"
            >
              {firstName}, your learning journey starts here.
            </Typography>
            <Typography variant={"body"} className="text-[20px] font-bold ">
              Discover programs designed for your success
            </Typography>
          </div>
          {/* <Button
            variant={"text"}
            endAdornment={<ArrowRight />}
            className="mt-2 pl-0"
          >
            Explore More
          </Button> */}
        </div>
        <PgctlProgramCard />
        <MedProgramCard />
      </div>
    </div>
  )
}

export default GetStartedBannerForCourses
